import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { TimelineUpsertNewShiftV2 } from '@wilson/shift-timeline/state';
import { TimelineShift } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class TimelineAdjustTimeService {
  private readonly store = inject(Store);

  public adjustV2TimelineShiftTime(shiftToUpdate: TimelineShift): void {
    this.store.dispatch([
      new TimelineUpsertNewShiftV2({
        shift: shiftToUpdate,
      }),
    ]);
  }

  public adjustV2TimelineShiftTimeAndUpdateValidations(
    shiftToUpdate: TimelineShift,
  ): void {
    this.adjustV2TimelineShiftTime(shiftToUpdate);
  }
}
